export interface AssigningPreferenceReserveRequest {
  reserveId: number
  collectionId: number
  revision: number
}

export function AssigningPreferenceReserveRequestToJSON(
  value: AssigningPreferenceReserveRequest
): any {
  return {
    reserve_id: value.reserveId !== 0 ? value.reserveId : undefined,
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
